module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/810b3e67978393f7cb2635e41e07d538.png";